const rnChoices = [
  {
    name: "White Rice",
    price: 0,
  },
  {
    name: "Fried Rice",
    price: 0,
  },
  {
    name: "Shrimp Fried Rice",
    price: 3.25,
  },
  {
    name: "Pork Fried Rice",
    price: 3.25,
  },
  {
    name: "Beef Fried Rice",
    price: 3.25,
  },
  {
    name: "House Fried Rice",
    price: 4.75,
  },
  {
    name: "Veggie Lo Mein",
    price: 3.25,
  },
  {
    name: "Shrimp Lo Mein",
    price: 4.75,
  },
  {
    name: "Beef Lo Mein",
    price: 4.75,
  },
  {
    name: "Pork Lo Mein",
    price: 4.75,
  },
];

export default rnChoices;
